<template>
  <v-col cols="12" class="pa-0">
    <video-info-options
      :handleSelectOption="handleSelectOption"
      v-if="currentDisplay === 'options' && !isStreamingRightNow"
    />
    <video-traffic
      :handleBack="handleBackOptions"
      v-else-if="currentDisplay === 'traffic' && !isStreamingRightNow"
      :customVideoId="customVideoId"
    />
  </v-col>
</template>

<script>
import VideoTraffic from './VideoTraffic.vue'
import VideoInfoOptions from './VideoInfoOptions.vue'

export default {
  name: 'VideoInfo',
  props: [
    'isStreamingRightNow',
    'liveStatus',
    'serverStatus',
    'timeLeft',
    'errors',
    'liveInfo',
    'lastVerificationServer',
    'isLive',
    'customVideoId',
  ],
  components: { VideoInfoOptions, VideoTraffic },
  data: () => ({
    currentDisplay: 'options',
  }),
  methods: {
    handleSelectOption(option) {
      this.currentDisplay = option
    },
    handleBackOptions() {
      this.handleSelectOption('options')
    },
  },
}
</script>

<style></style>
